/** * 首页演示 * 徐杰 * 2019-4-23 **/
<template>
  <div>
    <X-Layout>
      <div :style="{ height: pageHeight + 'px' }" class="indexpage" ref="indexpage">
        <!-- 顶部数据 -->
        <div class="topbox">
          <div class="itembox" v-for="(item, index) in inforCardData" :key="index">
            <div class="itemleft">
              <img class="icondiv" :src="item.icon" />
              <div class="itemtext">{{ item.title }}</div>
            </div>
            <div class="itemright numcolor1" :class="'numcolor' + (index + 1)">
              <countTo :startVal="0" :endVal="item.nums" :duration="3000"></countTo>
            </div>
          </div>
        </div>
        <div class="bodybox">
          <!-- Mapbox 地图 -->
          <mapboxMap class="mapbox" ref="MapboxControl" :companyList="companyList"></mapboxMap>
          <div class="companybox">
            <!-- 切换 0工况  1油烟  2在线  3扬尘-->
            <div class="tabsbox">
              <Tabs type="card" v-model="activeTabs" @on-click="changeTabs">
                <TabPane name="0" label="工况" icon="icon iconfont icon-gongkuangtu"></TabPane>
                <TabPane name="1" label="油烟" icon="icon iconfont icon-youyanji"></TabPane>
                <TabPane name="2" label="在线" icon="icon iconfont icon-yangan"></TabPane>
                <TabPane name="3" label="扬尘" icon="icon iconfont icon-yangchen1"></TabPane>
              </Tabs>
            </div>

            <!-- 搜索 -->
            <div class="searchbox">
              <Input v-model="companyName" @on-enter="getCompanyInfo(1)" style="width: 200px" placeholder="搜索企业">
                <span slot="append" @click="getCompanyInfo(1)"><Icon type="ios-search-outline" /></span>
              </Input>
              <Select v-model="streetActive" style="width: 140px" @on-change="changeStreet">
                <Option v-for="item in jiedaoList" :value="item.street_id" :key="item.street_id">{{
                  item.street_name
                }}</Option>
              </Select>
            </div>
            <!-- 公司列表 -->
            <div class="warningbox">
              <!-- 选中颜色 selwarnitem -->
              <div
                class="warnitem"
                :class="companyIndex == index ? 'selwarnitem' : ''"
                v-for="(item, index) in companyList"
                :key="index"
                @click="showItemInfo(item, index)"
              >
                <!-- 正常图标 -->
                <img class="warnicon" v-if="item.status == 0" src="@/assets/images/index10.png" />
                <!-- 告警图标 -->
                <img class="warnicon" v-else src="@/assets/images/index9.png" />

                <div class="companyinfo">
                  <div class="comname">{{ item.company_name }}</div>
                  <div class="com_add">
                    <div class="address">
                      街道：<span>{{ item.street_name }}</span>
                    </div>
                    <div class="testadd">
                      测试点：<span>{{ item.num }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 分页 -->
            <div class="pagebox">
              <Page
                :total="total"
                :page-size="row"
                :current="page"
                show-sizer
                show-total
                size="small"
                :page-size-opts="[50, 100, 200]"
                @on-change="changeCurrent"
                @on-page-size-change="changeSize"
              />
            </div>
          </div>
        </div>
      </div>
    </X-Layout>
  </div>
</template>

<script>
import xInfoCard from '../components/xInfo-Card.vue';
import { mathEleHeight } from '@/utils/common';
import countTo from 'vue-count-to';

import mapboxMap from '@/components/mapboxMap/mapboxMap.vue';
export default {
  components: {
    xInfoCard,
    countTo,
    mapboxMap,
  },
  data() {
    return {
      companyIndex: -1, // 当前选中的公司
      activeTabs: '0', // 当前是那一项  0工况  1油烟  2在线  3扬尘
      companyName: '', // 搜索公司名称
      streetActive: '0', // 街道id
      jiedaoList: [], // 街道列表
      pageHeight: 0, // 当前页面的高度
      page: 1,
      row: 50,
      total: 0,
      companyList: [], // 公司列表
      // 顶部信息条
      inforCardData: [
        {
          title: '今日工况报警',
          icon: require('@/assets/images/index1.png'),
          nums: 0,
          color: 'rgba(255, 51, 0, 1)',
        },
        {
          title: '今日油烟报警',
          icon: require('@/assets/images/index3.png'),
          nums: 0,
          color: 'rgba(255, 51, 0, 1)',
        },
        {
          title: '今日在线报警',
          icon: require('@/assets/images/index4.png'),
          nums: 0,
          color: 'rgba(255, 51, 0, 1)',
        },
        {
          title: '今日扬尘报警',
          icon: require('@/assets/images/index2.png'),
          nums: 0,
          color: 'rgba(255, 51, 0, 1)',
        },

        {
          title: '工况设备数',
          icon: require('@/assets/images/index5.png'),
          nums: 0,
          color: 'rgba(0, 204, 255, 1)',
        },
        {
          title: '油烟设备数',
          icon: require('@/assets/images/index7.png'),
          nums: 0,
          color: 'rgba(0, 204, 255, 1)',
        },

        {
          title: '在线设备数',
          icon: require('@/assets/images/index8.png'),
          nums: 0,
          color: 'rgba(0, 204, 255, 1)',
        },
        {
          title: '扬尘设备数',
          icon: require('@/assets/images/index6.png'),
          nums: 0,
          color: 'rgba(0, 204, 255, 1)',
        },
      ],

      tabsType: 0, // 0工况 1油烟 2在线 3视频
    };
  },
  mounted() {
    // 计算页面的高度
    this.pageHeight = mathEleHeight(this.$refs.indexpage, 20);

    this.getjinriInfor(); // 顶部标签数据

    this.getCompanyInfo(1); // 获取公司信息
    this.getjiedao(); // 获取街道列表
  },
  methods: {
    // 显示当前公司信息
    showItemInfo(info, index) {
      this.companyIndex = index;
      let control = this.$refs.MapboxControl || '';
      if (control) control.clickCompanyShowInfo(info);
    },
    // 上一页/下一页
    changeCurrent(num) {
      this.getCompanyInfo(num);
    },
    changeSize(e) {
      this.row = e;
      this.getCompanyInfo(1);
    },
    // tabs切换
    changeTabs() {
      console.log(this.activeTabs);
      this.companyName = '';
      this.streetActive = '0';
      this.getCompanyInfo(1);
    },
    // 选择街道
    changeStreet() {
      this.getCompanyInfo(1);
    },
    getCompanyInfo(page) {
      this.companyIndex = -1;
      const api = this.ApiUrl + 'nowData/mainfindComapny';
      const data = {
        type: this.activeTabs * 1, //  // 当前是那一项  0工况  1油烟  2在线  3扬尘
        page: page,
        row: this.row,
        company_name: this.companyName,
        street_id: this.streetActive,
      };
      // 请求数据
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            const list = res.data.extend.companyList;
            this.total = res.data.extend.total1; // 一共多条数据
            this.page = page;
            // 遍历数据，拆分后端返回的百度地图经纬度；地图组件会转换为 WGS-84。
            for (let i = 0; i < list.length; i++) {
              const thisxy = (list[i].xy || '').split(',');
              if (!list[i].wz) {
                list[i].wz = {};
                list[i].point = {};
                if (!list[i].wz.lng) {
                  list[i].wz.lng = thisxy[0];
                  list[i].point.lng = thisxy[0];
                }
                if (!list[i].wz.lat) {
                  list[i].wz.lat = thisxy[1];
                  list[i].point.lat = thisxy[1];
                }
              }
            }
            // 处理过的数据赋值 表格数据 和 地图标签
            this.companyList = list; // 表格数据赋值
            // 初始化数据时判断地图需不需要初始化
            if (this.companyList && this.companyList.length == 0) {
              let control = this.$refs.MapboxControl;
              if (control) {
                control.initMap();
              }
            }

            if (this.tabsType === 0) {
              // 工况
              // 地图组件通过 companyList 自动刷新企业标记。
            }
          }
        },
        res => {},
      );
    },

    /**
     * 顶部标签数据
     */
    getjinriInfor() {
      const api = this.ApiUrl + 'gkData/mainData';
      const data = {};
      this.$http.post(api, data).then(res => {
        if (res.data.extend.news === 0) {
          var list = res.data.extend;
          this.inforCardData[0].nums = list.gkTodayWarn ? list.gkTodayWarn * 1 : 0;
          this.inforCardData[1].nums = list.yyTodayWarn ? list.yyTodayWarn * 1 : 0;
          this.inforCardData[2].nums = list.companyNum ? list.companyNum * 1 : 0;
          this.inforCardData[3].nums = list.todayWarnEquipmentNum ? list.todayWarnEquipmentNum * 1 : 0;

          this.inforCardData[4].nums = list.countgkEquip ? list.countgkEquip * 1 : 0;
          this.inforCardData[5].nums = list.countyyEquip ? list.countyyEquip * 1 : 0;
          this.inforCardData[6].nums = list.countVideo ? list.countVideo * 1 : 0;
          this.inforCardData[7].nums = list.countYcEquip ? list.countYcEquip * 1 : 0;
        }
      });
    },
    // 获取街道列表
    getjiedao() {
      const that = this;
      const api = this.ApiUrl + 'street/findAll';
      const data = {};
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            const list = res.data.extend.pageInfo;
            const qb = {
              street_id: '0',
              street_name: '搜索全部',
            };
            list.unshift(qb);
            that.jiedaoList = list;
          }
        },
        res => {},
      );
    },

    /**
     * 跳转详情页
     */
    jumpDetails(id) {
      let _name = '';
      switch (
        this.tabsType // 判断当前选中的是 0工况 1油烟 2在线 3视频
      ) {
        case 0:
          _name = 'CSsystemIndex';
          break;
        case 1:
          _name = 'LampblackIndex';
          break;
        case 2:
          _name = 'online';
          break;
        case 3:
          _name = 'realTime';
          break;
      }
      sessionStorage.setItem('id', id);
      // 对应跳转
      this.$router.push({
        name: _name,
        params: {
          // 传参数
          id: id,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.indexpage {
  .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    padding: 5px 12px 4px;
  }
  .ivu-tabs-nav .ivu-tabs-tab .ivu-icon {
    margin-right: 4px;
  }
}
.anchorBL {
  display: none;
}
.ivu-page {
  white-space: nowrap;
}
</style>
<style scoped lang="scss">
.indexpage {
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: PingFang SC;
  .topbox {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px 40px;
    margin-bottom: 16px;
    .itembox {
      height: 72px;
      background: #fff;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      align-items: center;
      box-shadow: 0 0 2px #ccc;
      .itemleft {
        display: flex;
        align-items: center;
        .icondiv {
          display: block;
          width: 53px;
          height: 58px;
          margin-right: 15px;
        }
        .itemtext {
          font-size: 16px;
          font-weight: bold;
          line-height: 64px;
          color: #233c52;
        }
      }
      .itemright {
        font-size: 35px;
        font-weight: bold;
        line-height: 64px;
      }
      .numcolor1 {
        color: #e72d14;
      }
      .numcolor2 {
        color: #fa8b15;
      }
      .numcolor3 {
        color: #19be6b;
      }
      .numcolor4 {
        color: #0062ff;
      }

      .numcolor5 {
        color: #19be6b;
      }
      .numcolor6 {
        color: #0062ff;
      }
      .numcolor7 {
        color: #e72d14;
      }
      .numcolor8 {
        color: #fa8b15;
      }
    }
  }
  .bodybox {
    flex: 1;
    position: relative;
    background: #fff;
    padding: 16px;
    min-height: 400px;
    border-radius: 8px;
    .mapbox {
      width: 100%;
      height: 100%;
    }
    .companybox {
      position: absolute;
      top: 40px;
      right: 30px;
      width: 400px;
      height: 90%;
      background: #ffffff;
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);
      border-radius: 4px;
      z-index: 999;
      padding: 10px;
      display: flex;
      flex-direction: column;
      .tabsbox {
        flex: none;
      }
      .searchbox {
        flex: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
      }

      .warningbox {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        margin-bottom: 15px;
        .warnitem {
          flex: none;
          height: 60px;
          background: #f8f8f8;
          opacity: 1;
          border-radius: 4px;
          margin-bottom: 13px;
          padding: 0 15px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .warnicon {
            width: 36px;
            height: 36px;
            display: block;
            margin-right: 10px;
          }
          .companyinfo {
            display: flex;
            flex-direction: column;
            justify-content: center;
            overflow: hidden;
            .comname {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #333333;
              line-height: 1em;
              display: block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .com_add {
              display: flex;
              line-height: 1em;
              margin-top: 8px;
              color: #999999;

              .address {
                margin-right: 30px;
                span {
                  color: #333333;
                }
              }
              .testadd {
                span {
                  color: #333333;
                }
              }
            }
          }
        }
        .selwarnitem {
          background: rgba(0, 98, 255, 0.1);
        }
      }
      .pagebox {
        flex: none;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 27px;
        overflow: hidden;
      }
    }
  }
}
</style>
